import { Skeleton, Slot, Heading, Anchor, Text } from '@costar-ui/components';
import React from 'react';

var Name = function Name(props) {
  var label = props.label,
    href = props.href,
    _props$target = props.target,
    target = _props$target === void 0 ? '_blank' : _props$target,
    onNameClick = props.onNameClick,
    wrap = props.wrap,
    testId = props.testId,
    isLoading = props.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.5",
    className: "csg-tw-skeleton-name"
  }) : label && /*#__PURE__*/React.createElement(Slot, {
    className: "csg-tw-name"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    variant: "heading-18",
    className: wrap ? 'max-w-full break-words' : '',
    ellipsis: wrap ? undefined : '1',
    testId: testId
  }, onNameClick ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary",
    className: "overflow-hidden font-bold",
    onClick: onNameClick,
    testId: "name-link"
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: wrap ? undefined : '1',
    className: wrap ? 'max-w-full break-words' : ''
  }, label)) : href ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary",
    href: href,
    target: target,
    className: "overflow-hidden font-bold",
    testId: "name-link"
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: wrap ? undefined : '1',
    className: wrap ? 'max-w-full break-words' : ''
  }, label)) : label));
};

export { Name };
//# sourceMappingURL=name.esm.js.map
